import { render, staticRenderFns } from "./CommodityAllocationListDetail.vue?vue&type=template&id=312ab938&scoped=true&"
import script from "./CommodityAllocationListDetail.vue?vue&type=script&lang=js&"
export * from "./CommodityAllocationListDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommodityAllocationListDetail.vue?vue&type=style&index=0&id=312ab938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ab938",
  null
  
)

export default component.exports